import { gql } from '@apollo/client/core';

export const GET_CITIES = gql`
  query GetCities(
    $limit: Int!
    $offset: Int!
    $sortOrder: String!
    $search: String
    $isActive: Boolean
    $sortBy: String
  ) {
    cities(
      limit: $limit
      offset: $offset
      sortOrder: $sortOrder
      search: $search
      isActive: $isActive
      sortBy: $sortBy
    ) {
      cities {
        cityId
        name
        stateCode
        stateName
        latitude
        longitude
        isActive
      }
      total
      hasMore
    }
  }
`;
